import { render, staticRenderFns } from "./screen-test-fontautoscale.vue?vue&type=template&id=44c7702f"
import script from "./screen-test-fontautoscale.vue?vue&type=script&lang=js"
export * from "./screen-test-fontautoscale.vue?vue&type=script&lang=js"
import style0 from "./screen-test-fontautoscale.vue?vue&type=style&index=0&id=44c7702f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports